import { userRecord, userRecordV2 } from './index';
import { boxCollect } from '@/components/ElectronLayout/ElectronHead/popup/server';

export async function loginCollect(key?: any, data?: any) {
  await userRecord(key, data);
}

export async function loginCollectV2(key?: any, data?: any) {
  await userRecordV2(key, data);
}

export async function loginCollectV3(key?: any, data?: any) {
  await boxCollect(key, data);
}

// 0000	首次启动app/应用
// 1000	启动app/应用
// 1001	关闭app/应用
// 1002	底部导航-首页tab
// 1003	底部导航-发现tab
// 1100	日推tab
// 1101	日推tab-banner模块
// 1102	日推tab-游戏列表
// 1103	日推tab-游戏列表-获取按钮
// 1104	日推tab-游戏列表-启动按钮
// 1105	日推tab-游戏列表-游戏item
// 1200	预告tab
// 1201	预告tab-banner模块
// 1202	预告tab-游戏列表
// 1203	预告tab-游戏列表-获取按钮
// 1204	预告tab-游戏列表-启动按钮
// 1205	预告tab-游戏列表-游戏item
// 1300	排行tab
// 1301	排行tab-推荐榜tab
// 1302	排行tab-推荐榜tab-游戏列表
// 1303	排行tab-推荐榜tab-游戏列表-获取按钮
// 1304	排行tab-推荐榜tab-游戏列表-启动按钮
// 1305	排行tab-推荐榜tab-游戏列表-游戏item
// 1400	排行tab-新服榜tab
// 1401	排行tab-新服榜tab-游戏列表
// 1402	排行tab-新服榜tab-游戏列表-获取按钮
// 1403	排行tab-新服榜tab-游戏列表-启动按钮
// 1404	排行tab-新服榜tab-游戏列表-游戏item
// 1500	排行tab-人气榜tab
// 1501	排行tab-人气榜tab-游戏列表
// 1502	排行tab-人气榜tab-游戏列表-获取按钮
// 1503	排行tab-人气榜tab-游戏列表-启动按钮
// 1504	排行tab-人气榜tab-游戏列表-游戏item
// 1600	底部导航-发现tab-游戏列表
// 1601	底部导航-发现tab-游戏列表-游戏item
// 1700	PC/web推荐tab
// 1701	PC/web推荐tab-banner模块
// 1702	PC/web推荐tab-开服列表模块
// 1703	PC/web推荐tab-开服列表模块-开始游戏按钮
// 1704	PC/web推荐tab-开服列表模块-游戏item
// 1705	PC/web推荐tab-开服列表模块-游戏详情-下载游戏按钮
// 1706	PC/web推荐tab-开服列表模块-游戏详情-启动游戏按钮
// 1707	PC/web推荐tab-新服推荐模块
// 1708	PC/web推荐tab-新服推荐模块-游戏item
// 1709	PC/web推荐tab-新服推荐模块-游戏详情-下载游戏按钮
// 1710	PC/web推荐tab-新服推荐模块-游戏详情-启动游戏按钮
// 1711	PC/web推荐tab-排行榜模块-推荐榜
// 1712	PC/web推荐tab-排行榜模块-推荐榜-游戏item
// 1713	PC/web推荐tab-排行榜模块-推荐榜-游戏详情-下载游戏按钮
// 1714	PC/web推荐tab-排行榜模块-推荐榜-游戏详情-启动游戏按钮
// 1715	PC/web推荐tab-排行榜模块-新服榜
// 1716	PC/web推荐tab-排行榜模块-新服榜-游戏item
// 1717	PC/web推荐tab-排行榜模块-新服榜-游戏详情-下载游戏按钮
// 1718	PC/web推荐tab-排行榜模块-新服榜-游戏详情-启动游戏按钮
// 1719	PC/web推荐tab-排行榜模块-人气榜
// 1720	PC/web推荐tab-排行榜模块-新服榜-游戏item
// 1721	PC/web推荐tab-排行榜模块-人气榜-游戏详情-下载游戏按钮
// 1722	PC/web推荐tab-排行榜模块-人气榜-游戏详情-启动游戏按钮
// 1800	PC/web新服tab
// 1801	PC/web新服tab-今日开服tab
// 1802	PC/web新服tab-今日开服tab-开始游戏按钮
// 1803	PC/web新服tab-今日开服tab-游戏item
// 1804	PC/web新服tab-今日开服tab-游戏详情-下载游戏按钮
// 1805	PC/web新服tab-今日开服tab-游戏详情-启动游戏按钮
// 1806	PC/web新服tab-即将开服tab
// 1807	PC/web新服tab-即将开服tab-开始游戏按钮
// 1808	PC/web新服tab-即将开服tab-游戏item
// 1809	PC/web新服tab-即将开服tab-游戏详情-下载游戏按钮
// 1810	PC/web新服tab-即将开服tab-游戏详情-启动游戏按钮
// 1900	PC/web发现tab
// 1901	PC/web发现tab-游戏item
// 1902	PC/web发现tab-游戏详情-下载游戏按钮
// 1903	PC/web发现tab-游戏详情-启动游戏按钮
// 2000	PC/web排行tab
// 2001	PC/web排行tab-推荐榜分类
// 2002	PC/web排行tab-推荐榜分类-游戏item
// 2003	PC/web排行tab-推荐榜分类-游戏详情-下载游戏按钮
// 2004	PC/web排行tab-推荐榜分类-游戏详情-启动游戏按钮
// 2005	PC/web排行tab-新服榜分类
// 2006	PC/web排行tab-新服榜分类-游戏item
// 2007	PC/web排行tab-新服榜分类-游戏详情-下载游戏按钮
// 2008	PC/web排行tab-新服榜分类-游戏详情-启动游戏按钮
// 2009	PC/web排行tab-人气榜分类
// 2010	PC/web排行tab-人气榜分类-游戏item
// 2011	PC/web排行tab-人气榜分类-游戏详情-下载游戏按钮
// 2012	PC/web排行tab-人气榜分类-游戏详情-启动游戏按钮
// 2100	游戏详情页面
// 2101	游戏详情页面-获取按钮
// 2102	游戏详情页面-启动按钮
// 2200	H5-页面
// 2201	H5-banner
// 2202	H5-游戏详情页
// 2203	H5-下载盒子按钮
// 2204	H5-下载游戏按钮
// 3000	短信验证登录页面
// 3001	短信验证登录页面-手机号文本框
// 3002	短信验证登录页面-获取验证码按钮
// 3003	短信验证登录页面-验证码文本框(PC/Web)
// 3004	短信验证登录页面-下一步按钮(PC/Web)
// 3005	短信验证登录页面-注册按钮(PC/Web)
// 3006	短信验证登录页面-账号密码登录按钮
// 3007	短信验证登录页面-输入验证码页面
// 3008	短信验证登录页面-输入验证码页面-验证码文本框
// 3009	短信验证登录页面-输入验证码页面-获取验证码按钮
// 3010	短信验证登录页面-登录成功
// 3100	账号密码登录页面
// 3101	账号密码登录页面-账号文本框
// 3102	账号密码登录页面-密码文本框
// 3103	账号密码登录页面-登录按钮
// 3104	账号密码登录页面-免密登录按钮
// 3105	账号密码登录页面-短信验证登录按钮(PC/Web)
// 3106	账号密码登录页面-登录成功
// 3200	免密登录页面
// 3201	免密登录页面-手机号文本框
// 3202	免密登录页面-获取验证码按钮
// 3203	免密登录页面-密码登录按钮
// 3204	免密登录页面-输入验证码页面
// 3205	免密登录页面-输入验证码页面-验证码文本框
// 3206	免密登录页面-输入验证码页面-获取验证码按钮
// 3207	免密登录页面-登录成功
// 3300	账号注册页面
// 3301	账号注册页面-账号文本框
// 3302	账号注册页面-密码文本框
// 3303	账号注册页面-下一步按钮
// 3304	账号注册页面-绑定手机号页面
// 3305	账号注册页面-绑定手机号页面-手机号文本框
// 3306	账号注册页面-绑定手机号页面-获取验证码按钮
// 3307	账号注册页面-绑定手机号页面-验证码文本框
// 3308	账号注册页面-绑定手机号页面-登录按钮
// 3309	账号注册页面-绑定手机号页面-登录成功
// 4000	邀请赚钱-按钮点击
// 4001	邀请赚钱-分享QQ
// 4002	邀请赚钱-分享微信
// 4003	邀请赚钱-分享朋友圈
// 4004	邀请赚钱-H5分享页点击
// 4005	邀请赚钱-分享（废弃）
// 4101	会员系统-首页-会员icon点击
// 4102	会员系统-我的-会员icon点击
// 4103	会员系统-会员页-点击开通按钮
// 4104	会员系统-会员页-点击支持按钮（跳转可充值游戏列表）
// 4105	会员系统-会员页-点击兑换按钮
// 4106	会员系统-会员页-点击支付按钮
// 4107	会员系统-首页-最终成为会员（包含支付和兑换）(客户端不需要打点)
// 4108	会员系统-我的-最终成为会员（包含支付和兑换）(客户端不需要打点)
// 4109	会员系统-点击续费按钮
// 4110	会员系统-点击续费支付按钮
// 4111	会员系统-续费支付成功（包换支付和兑换）(客户端不需要打点)
// 4112	会员系统-领取充值券成功
// 4113	会员系统-首页会员按钮-非会员进入
// 4114	会员系统-我的会员按钮-非会员进入
// 5000	启动游戏报错
// 5001	写入文件报错
// 5002	启动游戏服务端接口报错
// 7200	进入积分商城
// 7201	积分商城点击商品详情
// 7202	积分商城兑换商品

// 3000	短信验证登录页面
// 3001	短信验证登录页面-手机号文本框
// 3002	短信验证登录页面-获取验证码按钮
// 3003	短信验证登录页面-验证码文本框(PC/Web)
// 3004	短信验证登录页面-下一步按钮(PC/Web)
// 3005	短信验证登录页面-注册按钮(PC/Web) ps: 新pc短信登录页面没有注册入口
// 3006	短信验证登录页面-账号密码登录按钮
// 3007	短信验证登录页面-输入验证码页面 ps: pc端验证码不是处不是独立页面
// 3008	短信验证登录页面-输入验证码页面-验证码文本框 ps: 和上面一样
// 3009	短信验证登录页面-输入验证码页面-获取验证码按钮 ps: 和上面一样
// 3010	短信验证登录页面-登录成功
// 3100	账号密码登录页面
// 3101	账号密码登录页面-账号文本框
// 3102	账号密码登录页面-密码文本框
// 3103	账号密码登录页面-登录按钮
// 3104	账号密码登录页面-免密登录按钮 ps: 无
// 3105	账号密码登录页面-短信验证登录按钮(PC/Web)
// 3106	账号密码登录页面-登录成功
// 3300	账号注册页面
// 3301	账号注册页面-账号文本框
// 3302	账号注册页面-密码文本框
// 3303	账号注册页面-下一步按钮
// 3304	账号注册页面-绑定手机号页面
// 3305	账号注册页面-绑定手机号页面-手机号文本框
// 3306	账号注册页面-绑定手机号页面-获取验证码按钮
// 3307	账号注册页面-绑定手机号页面-验证码文本框
// 3308	账号注册页面-绑定手机号页面-登录按钮
// 3309	账号注册页面-绑定手机号页面-登录成功
